import { render, staticRenderFns } from "./LandingSection.vue?vue&type=template&id=2d4e2030&scoped=true&"
import script from "./LandingSection.vue?vue&type=script&lang=js&"
export * from "./LandingSection.vue?vue&type=script&lang=js&"
import style0 from "./LandingSection.vue?vue&type=style&index=0&id=2d4e2030&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e2030",
  null
  
)

export default component.exports